import React from 'react';
import { shape, string } from 'prop-types';
import qs from 'query-string';
import { Query } from 'react-apollo';
import withApplicationConfig from 'containers/withApplicationConfig';
import Layout from 'components/layout';
import { LoadingIndicator } from 'components/common';
import {
  getAuthQueryVariables, getStaticText, getImages,
} from 'helpers/Utils';
import Queries from '../../queries';
import Unsubscribe from './Unsubscribe';

const UnsubscribePage = ({
  location,
  localisation,
  language,
  contentstackKeys,
}) => {
  const { search } = location;
  const parsedSearch = qs.parse(search);
  const token = parsedSearch && parsedSearch.token;
  return (
    <Query
      query={Queries.GetNewsletterUnsubscribePage}
      variables={{
        language: localisation[language],
        ...getAuthQueryVariables({
          contentstackKeys,
          initailStaticTextKeys: contentstackKeys.staticTextKeys.unsubscribe,
        }),
      }}
    >
      {({ data, refetch, loading }) => {
        if (!data || loading) {
          return <LoadingIndicator />;
        }

        const staticText = getStaticText(data);

        return (
          <Layout
            {...data.pageConfig}
            componentConfig={data?.componentConfig}
            seoMetaData={data.seoMetadata}
            customerProfile={data?.customerProfile}
            staticText={staticText}
            images={getImages(data)}
            refetch={refetch}
          >
            <Unsubscribe
              token={token}
              title={staticText.UNSUBSCRIBE_PAGE_TITLE}
              p1={staticText.UNSUBSCRIBE_PAGE_PARAGRAPH}
              img={staticText.UNSUBSCRIBE_PAGE_IMAGE}
            />
          </Layout>
        );
      }
    }
    </Query>
  );
};

UnsubscribePage.propTypes = {
  location: shape({}).isRequired,
  localisation: shape({}).isRequired,
  language: string.isRequired,
  contentstackKeys: shape({}).isRequired,
};

export default withApplicationConfig(UnsubscribePage, ['languages', 'unsubscribe', 'contentstackKeys']);
